import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconFilterProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconFilter: React.FC<IconFilterProps> = ({
    color = 'inherit',
    size = 'md',
    className = '',
    title = 'Filter',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
                d="M4 6h16M7 12h10M10 18h4"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    </IconBase>
);

export default IconFilter;
